import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { getErrors, getResData } from "../../shared/utility";

const getNotificationStart = () => {
  return {
    type: actionTypes.GET_NOTIFICATION_START,
  };
};

const getNotificationSuccess = (notifications: any) => {
  return {
    type: actionTypes.GET_NOTIFICATION_SUCCESS,
    notifications,
  };
};

const getNotificationFailed = (error: any) => {
  return {
    type: actionTypes.GET_NOTIFICATION_FAIL,
    error,
  };
};

export const getNotification = (data: any) => {
  return async (dispatch: any) => {
    dispatch(getNotificationStart());

    return axios
      .post(`/user/notifications`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");

        if (response) {
          const data = getResData(response.data);

          if (!data.success) throw new Error(getErrors(data));

          return dispatch(getNotificationSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getNotificationFailed(getErrors(err))));
  };
};

export const getUserImage = (data: string) => {
  return axios
    .get(`/profile/picture/load/${data}`)
    .then((response: any) => {

      if (!response) throw new Error("No Response");
      const data = getResData(response.data);

      if (!data.success) throw new Error(getErrors(data));

      return data;
    })
    .catch((error: any) => console.log(error));
};

// Delete notification 
const deleteNotificationStart = () => {
  return {
    type: actionTypes.DELETE_NOTIFICATION_START,
  };
};

const deleteNotificationSuccess = (notificationId: number) => {
  return {
    type: actionTypes.DELETE_NOTIFICATION_SUCCESS,
    notificationId,
  };
};

const deleteNotificationFailed = (error: any) => {
  return {
    type: actionTypes.DELETE_NOTIFICATION_FAIL,
    error,
  };
};

export const deleteNotification = (reqBody: any) => {
  return async (dispatch: any) => {
    dispatch(deleteNotificationStart());

    return axios
      .post(`/user/notification/delete`, reqBody)
      .then((response) => {
        if (!response) throw new Error("No Response");

        if (response) {
          const data = getResData(response.data);

          if (!data.success) throw new Error(getErrors(data));

          return dispatch(deleteNotificationSuccess(reqBody?.id));
        }
      })
      .catch((err) => dispatch(deleteNotificationFailed(getErrors(err))));
  };
};


